var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder-container"},[_vm._t("default"),_c('span',{staticClass:"placeholder"},[_vm._v(_vm._s(_vm.placeholder))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }